import { Inject, Injectable, Injector } from '@angular/core';
import { BaseService } from '../base.service';
import { IAppConfig } from '../Config/app-config.model';
import { PagedPublicationHistoryList } from '../publication-history/PagedPublicationHistoryList';

@Injectable({
  providedIn: 'root'
})
export class RecentDecisionService extends BaseService {
  
  constructor(public _injector: Injector, @Inject('appconfig') private configParam: IAppConfig) {
    super(_injector);
   }

  GetRecentDecisionList(certificateType: string) {
    let QueryStr = '';
    QueryStr = this.FilterSubType(certificateType, QueryStr);
    QueryStr = `${this.configParam.ApiConfig.API_ENDPOINT}RecentDecision?${QueryStr}`;
    return this.Get<PagedPublicationHistoryList>(QueryStr);
  }

  private FilterSubType(subType: string, QueryStr: string) {
    if (subType && subType.length > 0 && subType !== 'Select One') {
      QueryStr += 'subType=' + subType + '&';
    }
    return QueryStr;
  }
}
